var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_401_54",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 5H5V35H35V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_401_54)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1875 11.2388L34.0625 7.50002L31.25 9.36752L30.7025 9.64127C29.585 8.34002 27.9463 7.50002 26.0938 7.50002C22.7281 7.50002 20 9.75189 20 13.11C20 13.5675 20.06 14.4769 20.1556 14.9025L20 14.9813C20 14.9813 7.8125 13.11 6.875 8.43377C6.875 8.43377 4.0625 13.11 8.75 16.8506C8.75 16.8506 6.875 17.7863 5.9375 16.8506C5.9375 16.8506 5.9375 19.6575 10.625 22.4625C10.625 22.4625 8.75 23.3963 7.8125 22.4625C7.8125 22.4625 11.5625 26.2013 13.4375 26.2013C13.4375 26.2013 13.4375 29.01 5 29.01C5 29.01 15.6669 36.0206 25.625 28.0744C30.6875 24.0338 31.9194 18.915 31.9869 15.0544C32.105 14.58 32.1875 14.0906 32.1875 13.5788V13.11L35 10.305L32.1875 11.2388Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6b8413ad5fcca6f6b921e6a51c50e664.svg";
export { ForwardRef as ReactComponent };